import React from 'react';

import FiltersSettings from './FiltersSettings';
import { FILTERS_MODE_GENERAL } from './constants';

const defaultIsFilterVisible = () => true;

export const FiltersSettingsProvider = ({
  children,
  favorites,
  onChangeFavorites,
}) => {
  const isFilterFavorite = ({ name }) => favorites?.includes(name);

  const handleToggleFavorite = ({ name }) => {
    onChangeFavorites(
      favorites?.includes(name)
        ? favorites.filter((item) => item !== name)
        : [...(favorites || []), name]
    );
  };

  return (
    <FiltersSettings.Provider
      value={{
        mode: FILTERS_MODE_GENERAL,
        isFilterVisible: defaultIsFilterVisible,
        isFilterFavorite,
        onToggleFavorite: handleToggleFavorite,
      }}
    >
      {children}
    </FiltersSettings.Provider>
  );
};

export default FiltersSettingsProvider;
